import getElementAttribute from '../accessors/get-element-attribute';
import DEFAULT_OPTIONS from '../constants/default-options';
import setElementAttribute from './set-element-attribute';
import createResponsiveValue from '../helpers/create-responsive-value';

const setResponsiveAttribute = (elementId, attr, value, breakpoint, options = DEFAULT_OPTIONS) => {
  const attrValue = getElementAttribute(elementId, attr) || '';

  const responsiveValue = createResponsiveValue(value, attrValue, breakpoint);

  return setElementAttribute(elementId, attr, responsiveValue, options);
};

export default setResponsiveAttribute;
